import ENDPOINTS from '../constants/endpoints'; // keep for other endpoints, but do not use for getSelectedPiecesForArticle
import apiClient from '../config/axios';
const BASE_URL = ENDPOINTS.INTERVENTIONS;
export const interventionService = {
  
  getInterventions: async (pageSize = 10, page = 1, filters = {}) => {
    try {
      const url = `${ENDPOINTS.INTERVENTIONS}/${pageSize}/${page}`;
      const params = {};
      if (filters.clientId) params.clientId = filters.clientId;
      if (filters.dateDebut) params.dateDebut = filters.dateDebut;
      if (filters.dateFin) params.dateFin = filters.dateFin;
      if (filters.searchTerms) params.searchTerms = filters.searchTerms;
      if (filters.cloture) params.cloture = filters.cloture;
      const response = await apiClient.get(url, { params });
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Erreur lors du chargement des interventions',
        error: error.response?.data,
      };
    }
  },

  createEntretien: async ({ interventionId, articleId, pieceDeRechangeEtServices }) => {
    try {
      const response = await apiClient.post(ENDPOINTS.ENTRETIEN, {
        interventionId,
        articleId,
        pieceDeRechangeEtServices,
      });
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Erreur lors de la création de l\'entretien',
        error: error.response?.data,
      };
    }
  },

  getArticleHistory: async (articleId) => {
    try {
      const response = await apiClient.get(`${ENDPOINTS.ARTICLE_HISTORY}/${articleId}`);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || "Erreur lors du chargement de l'historique",
        error: error.response?.data,
      };
    }
  },

  getSelectedPiecesForArticle: async (articleId, interventionId) => {
    try {
      const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
      const url = `${API_BASE_URL}/Article/PieceArticle/${articleId}/${interventionId}`;
      const response = await apiClient.get(url);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Erreur lors du chargement des pièces sélectionnées',
        error: error.response?.data,
      };
    }
  },

  getInterventionById: async (id) => {
    try {
      const response = await apiClient.get(`${BASE_URL}/${id}`);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || "Erreur lors du chargement de l'intervention",
        error: error.response?.data,
      };
    }
  },

  getWarningHistory: async (interventionId) => {
    try {
      const response = await apiClient.get(`${BASE_URL}/Warnning/${interventionId}`);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Erreur lors du chargement des avertissements',
        error: error.response?.data,
      };
    }
  },

  createIntervention: async (data) => {
    try {
      const response = await apiClient.post(BASE_URL, data);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || "Erreur lors de la création de l'intervention",
        error: error.response?.data,
      };
    }
  },

  updateIntervention: async (data) => {
    try {
      const response = await apiClient.put(BASE_URL, data);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || "Erreur lors de la modification de l'intervention",
        error: error.response?.data,
      };
    }
  },

  deleteIntervention: async (id) => {
    try {
      const response = await apiClient.delete(`${BASE_URL}/${id}`);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || "Erreur lors de la suppression de l'intervention",
        error: error.response?.data,
      };
    }
  }
  ,

  // Fetch rapport for an intervention
  getRapport: async (interventionId) => {
    try {
      const response = await apiClient.get(`${BASE_URL}/Rapport/${interventionId}`);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || "Erreur lors du chargement du rapport",
        error: error.response?.data,
      };
    }
  }
};

export default interventionService;